// extracted by mini-css-extract-plugin
module.exports = {"ImageX":"_3XY1t","imageX":"_3XY1t"};